import React from "react";
import Index from "@/pages/Index";
import About from "@/pages/About";
import Technology from "@/pages/Technology";
import Enterprise from "@/pages/Enterprise";
import Individual from "@/pages/Individual";
import Family from "@/pages/Family";
import Resources from "@/pages/Resources";
import Provider from "@/pages/Provider";
import LearnMore from "@/pages/LearnMore";
import Subscription from "@/pages/Subscription";
import Accessibility from "@/pages/legal/Accessibility";
import Payment from "@/pages/Payment";
import Verify from "@/pages/Verify";
import VideoTutorials from "@/pages/knowledge/VideoTutorials";
import BlogPage from "@/pages/blog";
import { RouteObject } from "react-router-dom";
import ProviderAssessment from "@/pages/provider/ProviderAssessment";
import ProviderCarePlanning from "@/pages/provider/ProviderCarePlanning";
import ProviderProgress from "@/pages/provider/ProviderProgress";
import CareTrack from "@/pages/CareTrack";
import ContactSales from "@/pages/ContactSales";
import DemoSchedule from "@/pages/DemoSchedule";
import HowItWorksPage from "@/pages/HowItWorksPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import { AuthCallback } from '@/pages/AuthCallback';
import CallTest from "@/CallTest";
import UserDashboard from "@/pages/UserDashboard";

export const publicRoutes: RouteObject[] = [
  {
    path: "/",
    element: <Index />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/technology",
    element: <Technology />,
  },
  {
    path: "/enterprise",
    element: <Enterprise />,
  },
  {
    path: "/individual",
    element: <Individual />,
  },
  {
    path: "/family",
    element: <Family />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "/portal/provider",
    element: <Provider />,
  },
  {
    path: "/provider/assessment",
    element: <ProviderAssessment />,
  },
  {
    path: "/provider/care-planning",
    element: <ProviderCarePlanning />,
  },
  {
    path: "/provider/progress",
    element: <ProviderProgress />,
  },
  {
    path: "/learn-more",
    element: <LearnMore />,
  },
  {
    path: "/subscription",
    element: <Subscription />,
  },
  {
    path: "/accessibility",
    element: <Accessibility />,
  },
  {
    path: "/payment",
    element: <Payment />,
  },
  {
    path: "/verify",
    element: <Verify />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "/video-tutorials",
    element: <VideoTutorials />,
  },
  {
    path: "/caretrack",
    element: <CareTrack />,
  },
  {
    path: "/caretrack/how-it-works",
    element: <HowItWorksPage />,
  },
  {
    path: "/contact-sales",
    element: <ContactSales />,
  },
  {
    path: "/schedule-demo",
    element: <DemoSchedule />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/payment-success",
    element: <PaymentSuccess />,
  },

  {
    path: "/request-callback",  // Add the new route for the CallTestPage
    element: <CallTest />,
  },

  {
    path: "/user-dashboard",
    element: <UserDashboard />,
  },

];
